import { apiService } from './api';
import { Kitchen, CreateKitchenRequest, ApiResponse } from '../types';

export const kitchenService = {
  async getKitchens(org: string, restaurantId?: string): Promise<Kitchen[]> {
    const response = await apiService.get<Kitchen[]>('/kitchens', { org, ...(restaurantId && { restaurantId }) });
    return response.data;
  },

  async createKitchen(data: CreateKitchenRequest): Promise<Kitchen> {
    const response = await apiService.post<Kitchen>('/kitchens', data);
    return response.data;
  },

  async updateKitchen(id: string, data: Partial<CreateKitchenRequest>): Promise<Kitchen> {
    const response = await apiService.put<Kitchen>(`/kitchens/${id}`, data);
    return response.data;
  },

  async toggleKitchenStatus(id: string, active: boolean): Promise<ApiResponse<null>> {
    const response = await apiService.patch<ApiResponse<null>>(`/kitchens/${id}/active`, { active });
    return response.data;
  },

  async deleteKitchen(id: string): Promise<ApiResponse<null>> {
    const response = await apiService.delete<ApiResponse<null>>(`/kitchens/${id}`);
    return response.data;
  },

  async hardDeleteKitchen(id: string): Promise<ApiResponse<null>> {
    const response = await apiService.delete<ApiResponse<null>>(`/kitchens/${id}/hard`);
    return response.data;
  }
};